/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class EnumDropDownItem {
        public text: string;
        public value: number;

        constructor(text: string, value: number) {
            this.text = text;
            this.value = value;
        }

        public static getDefaultSelectOption(): EnumDropDownItem {
            return new EnumDropDownItem('Select...',  null);
        }

        public static getDefaultAllOption(): EnumDropDownItem {
            return new EnumDropDownItem('All', null);
        }
    }
}